import client from './main-client';

export const getEmailTemplateApi = ({ id, params }) => client().get(`/email-templates
/${id}?dealId=${params.dealId}&originalTemplate=${params.originalTemplate
  || false}`, { ...params });
